<template>
  <el-tooltip class="item" effect="dark" :content="content" placement="top">
    <slot/>
  </el-tooltip>
</template>

<script>
export default {
  name:"K2ToolTip",
  props:["content"],
}
</script>